import useConfigService from 'src/service/config-service/hooks/useConfigService';
export default function useTranslationConfig() {
    return useConfigService('translations');
}
